import { CloseCircleOutlined } from '@ant-design/icons'

export function ErrorMessage(props) {
  const { error, getErrorText } = props

  const errorText = (error && error.message) || (getErrorText && getErrorText(error))

  return (
    errorText ?
    <>
      <div className = "error-message">
        <CloseCircleOutlined className = "error-icon"/>
        { errorText }
      </div>
      <br/>
    </> :
    undefined
  )
}
